import Upload from 'components/images/uploadproductapi-snapshot.jpg';
import UploadCsv from 'components/images/uploadproductcsv-snapshot.jpg';
import selectlanguage from 'components/images/selectlanguage-snapshot.jpg';
import selectAttribute from 'components/images/selectcolumnsindex-snapshot.png';
import * as React from 'react';
export default {
  Upload,
  UploadCsv,
  selectlanguage,
  selectAttribute,
  React
};